module.exports = __webpack_public_path__ + "static/media/X5-C.7df18062.png";